var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bundle && _vm.bundle.selectedBudget)?_c('simple-text',{attrs:{"content":_vm.bundle.selectedBudget.label}}):_c('div',[_vm._v(_vm._s(_vm._f("trans")('noBudget')))])}
var staticRenderFns = []

export { render, staticRenderFns }